module.exports = __webpack_public_path__ + "static/img/6-g.19d4a455.png";